/*
 * @Description: 请求处理
 * @Author: xiawenlong
 * @Date: 2020-12-16 19:57:59
 * @LastEditors: xiawenlong
 * @LastEditTime: 2022-10-11 08:59:05
 */
import axios from 'axios'
import codeMsg from './code-msg'
import { getCookie } from '@/utils/cookies'
class Http {
  constructor() {
    this.baseURL = process.env.VUE_APP_BASE_API
    // this.timeout = 5000
  }
  setInterceptor(instance) {
    instance.interceptors.request.use(
      config => {
        // TODO: 获取token
        const token = getCookie('myToken')
        // const token = 'ironge-user-4e159f0124034bb48893cf9b49b121e5'
        config.headers.authorization = token
        config.headers.client = 'manage'
        config.headers.terminal = 'Web'
        return config
      },
      error => {
        return Promise.reject(error)
      },
    )
    instance.interceptors.response.use(
      response => {
        const { code } = response.data
        switch (~~code) {
          case 0:
            return response.data
          case 100104:
            window.location.href = process.env.VUE_APP_FRONT_URL + 'login'
            return response.data
          case 100105:
            window.location.href = process.env.VUE_APP_FRONT_URL + 'login'
            return response.data
          default:
            return Promise.reject(response.data)
        }
      },
      error => {
        const { status = 404 } = error.response
        if (Object.prototype.hasOwnProperty.call(codeMsg, status)) {
          this.errorHandler(error, codeMsg[status])
        }
        throw error
      },
    )
  }
  // 异常处理器
  errorHandler(error, msg) {
    if (process.env.NODE_ENV === 'development') {
      console.group('❌ HTTP Error')
      console.log('错误信息：' + msg)
      console.log('接口地址：' + error.response.config.url)
      console.log(error)
      console.groupEnd()
    } else {
      return Promise.reject(error)
    }
  }
  mergeOptions(options) {
    return {
      baseURL: this.baseURL,
      timeout: this.timeout,
      ...options,
    }
  }
  request(options) {
    const instance = axios.create()
    const opts = this.mergeOptions(options)
    this.setInterceptor(instance)
    return instance(opts)
  }
  get(url, config = {}) {
    return this.request({
      method: 'get',
      url,
      ...config,
    })
  }
  post(url, data, config) {
    return this.request({
      method: 'post',
      url,
      data,
      ...config,
    })
  }
}
export default new Http()
